import React from "react";
import { createRoot } from "react-dom/client";
import { getPublicRuntimeEnv } from "./env.js";
import {
  OFFLINE_TRANSACTION_BOUNDARY,
  buildTransactionBoundaryNotice,
  validateMessageForOfflineTransactionBoundary,
} from "./offline-transaction-boundary.js";
import { createLiveMarketplaceService } from "./backend/live-marketplace.js";
import "./styles.css";

globalThis.React = React;
globalThis.ReactDOM = { createRoot };
globalThis.COPTIC_NEIGHBOR_ENV = getPublicRuntimeEnv();
globalThis.COPTIC_TRANSACTION_BOUNDARY = OFFLINE_TRANSACTION_BOUNDARY;
globalThis.COPTIC_TRANSACTION_NOTICE = buildTransactionBoundaryNotice;
globalThis.validateCopticNeighborMessage = validateMessageForOfflineTransactionBoundary;
globalThis.COPTIC_LIVE_MARKETPLACE = createLiveMarketplaceService();

async function boot() {
  await import("../data.js");
  await import("../ui.jsx");
  await import("../pages-public.jsx");
  await import("../pages-actions.jsx");
  await import("../pages-dashboard.jsx");
  await import("../pages-extra.jsx");
  await import("../tweaks-panel.jsx");
  await import("../app.jsx");
}

boot();
